var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
import { getDynamicToken } from "../../utils/getDynamicToken";
import { pxToRem } from "../../utils";
export default styled.footer.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-166qsa6-0"
})(["", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $marginTop = _ref2.$marginTop,
    theme = _ref2.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background-color: ", ";\n      margin-top: ", ";\n      padding-bottom: ", ";\n      padding-top: ", ";\n    "])), theme.vars.footer_color_background, getDynamicToken(theme.vars, "spacing_".concat($marginTop)), theme.vars.spacing_03, theme.vars.spacing_05);
});
export var StyledFooterWrapper = styled.div.withConfig({
  displayName: "styled__StyledFooterWrapper",
  componentId: "1_5_0__sc-166qsa6-1"
})(["", "{", "}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
}, function (_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: column;\n      margin: 0 auto;\n\n      @media (min-width: ", ") {\n        flex-direction: row;\n        justify-content: space-between;\n      }\n    "])), theme.breakpoint_md);
});
export var StyledFooterLinkWrapper = styled.div.withConfig({
  displayName: "styled__StyledFooterLinkWrapper",
  componentId: "1_5_0__sc-166qsa6-2"
})(["", "{", "}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.cssPrefix;
}, function (_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n\n      @media (min-width: ", ") {\n        flex-direction: row;\n      }\n    "])), theme.breakpoint_md);
});
export var StyledBackToTop = styled.div.withConfig({
  displayName: "styled__StyledBackToTop",
  componentId: "1_5_0__sc-166qsa6-3"
})(["", "{", "}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.cssPrefix;
}, function (_ref8) {
  var theme = _ref8.theme;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      border-bottom: ", "rem solid white;\n      margin-bottom: 1rem;\n      order: -1;\n      padding-bottom: 1.5rem;\n\n      @media (min-width: ", ") {\n        border: 0;\n        display: inline-block;\n        margin-bottom: 0;\n        order: 0;\n        padding: 0;\n        white-space: nowrap;\n      }\n    "])), pxToRem(1), theme.breakpoint_md);
});